// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__MDkj6","iconWithCounter":"styles_iconWithCounter__WOiDm","counterForLabel":"styles_counterForLabel__SzDuE","counterForIcon":"styles_counterForIcon__5gAqN"};